export default __webpack_public_path__ + "static/media/iconSpinnerPink.b0d1c250.svg";